/* eslint-disable @ngrx/prefer-effect-callback-in-block-statement */
import { inject, Injectable } from '@angular/core';

import { of } from 'rxjs';
import {
  catchError,
  filter,
  map,
  mergeMap,
  switchMap,
  take,
} from 'rxjs/operators';

import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';

import { getIsLoggedIn } from '@schaeffler/azure-auth';

import { RoleDescriptions } from '../../../auth/models/roles.models';
import { RoleDescriptionsService } from '../../../auth/services/role-descriptions.service';
import {
  loadRoleDescriptions,
  loadRoleDescriptionsFailure,
  loadRoleDescriptionsSuccess,
} from '../../actions';

@Injectable()
export class RolesEffects implements OnInitEffects {
  private readonly actions$ = inject(Actions);
  private readonly roleDescriptionsService = inject(RoleDescriptionsService);
  private readonly store = inject(Store);
  private readonly msalBroadcastService = inject(MsalBroadcastService);

  loadRoleDescriptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadRoleDescriptions),
      switchMap(() =>
        this.msalBroadcastService.inProgress$.pipe(
          filter(
            (status: InteractionStatus) => status === InteractionStatus.None
          ),
          take(1)
        )
      ),
      switchMap(() =>
        this.store.select(getIsLoggedIn).pipe(
          filter((isLoggedIn) => isLoggedIn),
          take(1)
        )
      ),
      mergeMap(() =>
        this.roleDescriptionsService.getRoleDescriptions().pipe(
          map((roleDescriptions: RoleDescriptions) =>
            loadRoleDescriptionsSuccess({ roleDescriptions })
          ),
          catchError((errorMessage) =>
            of(loadRoleDescriptionsFailure({ errorMessage }))
          )
        )
      )
    )
  );

  /**
   * Initially load role descriptions when user logs in
   */
  ngrxOnInitEffects(): Action {
    return loadRoleDescriptions();
  }
}
